export const MANUAL_ALERT_CONFIRMATION = "CHECK REAL SLACK ALERTS";
export type ManualAlertCheck = {
  requestId: string;
  checkedAt: string;
  finishedAt?: string;
  refreshRunId?: string;
  state: "checking" | "completed" | "blocked" | "incomplete";
  message: string;
  reasonCode?: import("./account-alert-recovery").AlertEvidenceReason;
  accepted: number;
  alreadyDelivered: number;
  rejected: number;
  uncertain: number;
  pending: number;
  noAlert: number;
  suppressed: number;
};
